const TempCache = {
    VISITOR_HISTORY_COOKIE: 'livechat_visitor_history',
    CHAT_IN_PROGRESS_COOKIE: 'livechat_chat_in_progress',
    CHAT_START_POPUP_DISMISSED: 'livechat_chat_start_popup_dismissed',
    CHAT_START_POPUP_CONSENT_ACCEPTED: 'livechat_chat_start_popup_accepted',
    CHAT_START_POPUP_OPENED: 'livechat_chat_start_popup_opened',
    CHAT_START_POPUP_PROMPTED: 'livechat_chat_start_popup_prompted',
    CHAT_START_POPUP_OPEN_MODE: 'livechat_chat_start_popup_open_mode',
    CHAT_START_POPUP_TAB_ID: 'livechat_chat_start_popup_tab_id',
    CHAT_START_POPUP_SOURCE_TAB: 'livechat_chat_start_popup_source_tab',
    VISITORINFO_IN_PROGRESS_COOKIE: 'livechat_visitorinfo_in_progress',
    RL_VISITOR_HISTORY_COOKIE: 'rl_visitor_history',
    VISITOR_ID_COOKIE: 'livechat_visitor_id',
    AGENT_ALIAS_ID_COOKIE: 'livechat_agent_alias_id',
    OPERATOR_ID_COOKIE: 'livechat_operator_id',
    PROFILE_ID_COOKIE: 'livechat_profile_id',
    CHAT_ID_COOKIE: 'livechat_chat_id',
    CHAT_TOKEN_COOKIE: 'livechat_chat_token',
    CHAT_START_DONE: 'livechat_chat_start_done',
    EXIT_POPUP_CHAT_ID: 'livechat_server_chatid',
    chatLanguage: 'eng', // default langauge
    videoGreetSwitchedLanguage: '',
    CHAT_STATE: 'livechat_chat_state',
    CHAT_SOUND_ENABLED: 'livechat_chat_sound_enabled',
    TRANSFER_TO_LIVE_AGENT: 'livechat_transfer_live_agent',
    APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE: 'livechat_prechat_message_ids',
    APEXCHAT_PRECHAT_MAPPED_QUESTION_COOKIE: 'livechat_prechat_mapped_question',
    APEXCHAT_PRECHAT_MESSAGE_SENT_COOKIE: 'livechat_prechat_message_sent',
    MINIMUM_DESKTOP_WIDTH: 800,
    PRECHAT_Rounded_Message_Popup_Last_Height: 300,
    PRECHAT_Rounded_Message_Popup_Current_Height: 290,
    IDLE_TYPING_THRESHOLD: 3, // # seconds after which to send the idle update
    UNICODE_CH: ['u00AD', 'u0020', 'u2063', 'u00A0', 'u200B'], // unicode invisible character on mobile
    UNICODE_EN: ['%C2%AD', '%20', '%E2%81%A3', '%C2%A0', '%E2%80%8B'], // encoded unicode invisible character
    UNICODE_INDEX: 0,
    CHAT_BAR_Z_INDEX: 10000000,
    CONTAINER_Z_INDEX: 9999999,
    FAKE_AGENT_ID: 999999999,
    EP_INITIAL_LOAD_TIME: null,
    Handle_ExitPopupMouseOut: () => { },
    WINDOWED_CHAT_STARTED: false,
    EP_SetTimeOut: null,
    AUTOGREET_AGENT_ID: 888888888,
    EP_PREDEFINED_AGENT_ID: 999 /* dummy number to represent predefined msg */,
    SIMULATED_AGENT_ID: 2147483647, // /JIRA_3210 - int.MaxValue, // # userid for messages that come from the "agent" before we know who the agent is going to be
    IS_GREETING_QUESTIONTYPE: false,
    REMOVE_NON_ALPHANUMERIC: /[^a-zA-Z0-9]+/g,
    VISITOR_TRACKING_COOKIE: 'livechat_invitation_traffic_sources',
    WEB_SMS_COOKIE: 'livechat_web_sms_number',
    EP_SIDEPANEL_HEADER_TEXT: 'Hello',
    EP_SIDEPANEL_WELCOME_TEXT: 'We are ONLINE!<br>We hate to see you go',
    IS_PAGE_REFRESHED: 'livechat_is_page_refreshed',
    INVITATION_SHOWN: 'livechat_v3_invitation_shown',
    PreChat_Message_Counter: 'livechat_prechat_messagecounter',
    PreChat_Last_Message: 'livechat_prechat_lastmessage',
    PreChat_Message_IDs: 'livechat_prechat_message_ids',
    PreChat_Msg_Array: 'livechat_prechat_msg_array',
    PreChat_Messages_Store: 'livechat_prechat_messages_store',
    PreChat_Message_Sent: 'livechat_prechat_message_sent',
    POKE_MESSAGE_LastJoinBackTime: 'livechat_pokemessages_lastJoinBackTime', // saving responding time of visitor on pokeOverlay
    isStaticButtonRegistered: false,
    OriginalReferrer: 'livechat_original_referrer',
    Continue_Mapping_Applied: 'livechat_continue_mapping_applied',
    IDLE_MESSAGE_DELAY: 1,
    SMS_TRANSFER_CHAT_DELAY: 5,
    RENDER_QT_TIME: 1000, // time to render calendar time QT
    INPUT_OLD_VALUE: 'livechat_input_old_value',
    SUBSEQUENT_GREETING_COOKIE: 'subsequent_greeting_flag',
    SHOW_OPERATOR_NOT_FOUND_OVERLAY: 'livechat_show_operator_not_found_overlay',
    TRANSFER_CHAT_SUCCEED: 'transfer_chat_succeed',
    USER_REACT_ON_LOC_DISCLAIMER: 'user_reacts_on_loc_disclaimer',
    VISITOR_PHONE: 'livechat_visitor_phone',
    VISITOR_NAME: 'livechat_visitor_name',
    LIVE_THREE_LETTER_ISO_LANG: 'threeLetterISOLanguageName',
    LIVE_CONTACTINFO: 'apexchat_live_contactInfo',
    DOM_Auto_Launched: 'livechat_dom_auto_launched',
    DOM_Auto_Launched_First_Message_Sent: false,
    PopupMessage_INITIAL_LOAD_TIME: null,
    PopupMessage_SetTimeOut: null,
    isChatStartPopupRestricted: false
};
export default TempCache;
